import { createMarketplaceEventFactory } from '../index';
import type {
  MarketplaceEventProps,
  MarketplaceEventSchema,
  PartialPick,
  RequiredPick,
} from '../properties';

export type PageViewed = MarketplaceEventSchema<
  RequiredPick<
    PartialPick<
      MarketplaceEventProps,
      | 'screen'
      | 'category'
      | 'collectionId'
      | 'companyName'
      | 'embed'
      | 'filters'
      | 'hostApp'
      | 'inAppOrPublic'
      | 'installed'
      | 'listingId'
      | 'pageNumber'
      | 'queryType'
      | 'referrer'
      | 'resultCount'
      | 'search'
      | 'sections'
      | 'sessionUrlParams'
      | 'slug'
      | 'sorts'
      | 'sourceId'
      | 'subscreen'
      | 'type'
    >,
    'screen'
  >
>;

export const getPageViewedEvent = createMarketplaceEventFactory<PageViewed>(
  'Marketplace',
  'Page Viewed'
);
